module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "adventure": _vm.adventure,
      "adventureId": _vm.adventureId,
      "chapter": _vm.chapter,
      "chapterId": _vm.chapterId,
      "stageId": _vm.stageId,
      "stage": _vm.stage
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "display": "block",
      "background-color": "white",
      "margin-top": "20px"
    },
    attrs: {
      "id": "page-stage-compose"
    }
  }, [_c('div', {
    staticClass: "mdl-cell  mdl-cell--12-col mdl-grid",
    staticStyle: {
      "background-color": "white",
      "text-align": "left"
    }
  }, [_c('h5', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_vm._v("Compose Stage")]), _vm._v(" "), (_vm.selectedInstanceId) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-grid",
    attrs: {
      "id": "objectDetails"
    }
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": "objectType",
      "name": "objectType"
    },
    on: {
      "change": _vm.changeObjectType
    }
  }, [_c('option', {
    attrs: {
      "value": "object"
    },
    domProps: {
      "selected": _vm.selectedInstance.type === 'object'
    }
  }, [_vm._v("Stage Object")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "path"
    },
    domProps: {
      "selected": _vm.selectedInstance.type === 'path'
    }
  }, [_vm._v("Path")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "decoration"
    },
    domProps: {
      "selected": _vm.selectedInstance.type === 'decoration'
    }
  }, [_vm._v("Decoration")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Object Type")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.selectedInstance.type === 'path') ? _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    class: {
      'is-none': _vm.selectedInstance.path === ''
    },
    attrs: {
      "id": "stagePath",
      "name": "stagePath"
    },
    on: {
      "change": _vm.changeObjectPath
    }
  }, [_c('option', {
    staticClass: "is-none",
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": _vm.selectedInstance.path === ''
    }
  }, [_vm._v("none")]), _vm._v(" "), _vm._l((_vm.chapter.stages), function(stage, stageKey) {
    return _c('option', {
      attrs: {
        "value": "stage"
      },
      domProps: {
        "value": stageKey,
        "selected": _vm.selectedInstance.path === stageKey
      }
    }, [_vm._v(_vm._s(stage.name))])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Path to...")]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.selectedInstance.text
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": _vm.selectedInstance.text
    },
    on: {
      "input": _vm.changeInstanceText
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Instance Text...")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    attrs: {
      "disabled": "",
      "id": "objectType",
      "name": "objectType"
    }
  }, _vm._l((_vm.chapter.objects), function(object, objectKey) {
    return _c('option', {
      attrs: {
        "value": "object"
      },
      domProps: {
        "value": objectKey,
        "selected": _vm.selectedInstance.objId === objectKey
      }
    }, [_vm._v(_vm._s(object.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Object Source")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-button--raised ",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.maximizeInstance
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out_map")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.removeInstance
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")]), _vm._v("Remove")])])]) : _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-grid",
    attrs: {
      "id": "objectDetails"
    }
  }, [_vm._v("\n        No object selected.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "dropzone",
    style: ('position: relative; width: 100%; padding: 28.125% 0 28.125% 0; background-color: #aaa; background-repeat: no-repeat; background-size: contain; background-position: center; background-image: url(' + _vm.stage.bg + ')'),
    attrs: {
      "id": "mydropzone"
    }
  }, _vm._l((_vm.stage.instances), function(instance, instanceKey) {
    return _c('div', {
      class: _vm.selectionClass(instanceKey) + ' dropped-element',
      style: ('opacity: 0.9; transform: translate(' + _vm.dimTools.dimFullToView(instance.left, 'mydropzone') + 'px, ' + _vm.dimTools.dimFullToView(instance.top, 'mydropzone') + 'px); height:' + _vm.dimTools.dimFullToView(instance.height, 'mydropzone') + 'px; width:' + _vm.dimTools.dimFullToView(instance.width, 'mydropzone') + 'px; background-image: url(' + instance.bg + '); background-color: rgba(1,0,1,0.2); background-repeat: no-repeat; background-size: contain;  background-position: center; position: absolute;'),
      attrs: {
        "name": instanceKey,
        "data-x": _vm.dimTools.dimFullToView(instance.left, 'mydropzone'),
        "data-y": _vm.dimTools.dimFullToView(instance.top, 'mydropzone')
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "mdl-grid",
    attrs: {
      "id": "objectCollection"
    }
  }, [_vm._l((_vm.chapter.objects), function(object, objectKey) {
    return _c('div', {
      staticClass: "mdl-cell mdl-cell--6-col draggable drag-element-source",
      style: ('height:80px; width:100px; background-color: rgba(0,70,200,0.5); background-repeat: no-repeat; background-size: contain;  background-position: center; background-image: url(' + object.bg + ')'),
      attrs: {
        "name": objectKey,
        "bg": object.bg
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "none",
        "color": "white",
        "text-align": "center",
        "text-shadow": "0 0 3px rgba(0,0,0,0.5)",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(object.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "#999"
    }
  }, [_vm._v("\n            DRAG AND DROP ELEMENTS FROM HERE TO THE STAGE\n          ")])], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0232f936!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionStageCompose.vue
// module id = 301
// module chunks = 0